import React from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { Menubar } from 'primereact/menubar';
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import './App.css';
import './theme.css';
import 'primereact/resources/primereact.min.css';


import Footer from './pages/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Team from './pages/Team';
import Infrastructure from './pages/Infrastructure';
import Academics from './pages/Academics';
import BeyondAcademics from './pages/BeyondAcademics';
import Admissions from './pages/Admissions';
import Contact from './pages/Contact';
import MandatoryPublicDisclosures from './pages/MandatoryPublicDisclosures';
import PhotoGallery from './pages/PhotoGallery';
import DocumentViewer from './pages/DocumentViewer';
import NewMandatory from './pages/NewMandatory';

const App = () => {
  const navigate = useNavigate();
  const items = [
    // { label: 'Home', icon: 'pi pi-fw pi-home', url: '/' },
    {
      label: 'DIS Tiruvuru',
      // icon: 'pi pi-fw pi-building',
      command: () => navigate('/about')
    },
    // {
    //   label: 'Our Team',
    //   // icon: 'pi pi-fw pi-users',
    //   command: () => navigate('/team')
    // },
    {
      label: 'Infrastructure',
      // icon: 'pi pi-fw pi-cog',
      command: () => navigate('/infrastructure')
    },
    {
      label: 'Academics',
      // icon: 'pi pi-fw pi-book',
      command: () => navigate('/academics')
    },
    // {
    //   label: 'Beyond Academics',
    //   // icon: 'pi pi-fw pi-star',
    //   command: () => navigate('/beyond-academics')
    // },
    {
      label: 'Admissions',
      // icon: 'pi pi-fw pi-sign-in',
      command: () => navigate('/admissions')
    },
    {
      label: 'Mandatory Disclosures',
      // icon: 'pi pi-fw pi-file-pdf',
      command: () => navigate('/mandatory-public-disclosures')
    },
    {
      label: 'Contact',
      // icon: 'pi pi-fw pi-envelope',
      command: () => navigate('/contact')
    },
  ];


  return (
    <div className="App">
      <Menubar
        model={items}
        start={
          <img
            src="/logo.png"
            alt="DIS Tiruvuru Logo"
            style={{ height: '70px', marginRight: '1rem' }}
            onClick={() => navigate('/')}
          />
        }
        end={
          <div className="flex align-items-center gap-2">
            <Button
              label="Apply Now"
              className="p-button-rounded p-button-success p-button-sm"
            />
            <Button
              label="ERP Login"
              className="p-button-rounded bg-orange-600 p-button-sm"
            />
          </div>
        }
        className="mb-2"
      />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        {/* <Route path="/team" element={<Team />} /> */}
        <Route path="/infrastructure" element={<Infrastructure />} />
        <Route path="/academics" element={<Academics />} />
        <Route path="/beyond-academics" element={<BeyondAcademics />} />
        <Route path="/admissions" element={<Admissions />} />
        <Route path="/mandatory-public-disclosures" element={<NewMandatory />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/photo" element={<PhotoGallery />} />
        <Route
          path="/documents/affiliation-certificate"
          element={
            <DocumentViewer
              title="Affiliation Certificate (I-X)"
              pdf="/documents/Affiliation I-X Copy.pdf"
            />
          }
        />
        <Route
          path="/documents/drinking-water-sanitary"
          element={
            <DocumentViewer
              title="Drinking Water and Sanitary Condition"
              pdf="/documents/Annexure C Drinking Water and Sanitary Condition.pdf"
            />
          }
        />
        <Route
          path="/documents/building-safety"
          element={
            <DocumentViewer
              title="Building Safety Certificate"
              pdf="/documents/Annexure D Building Safety Certificate.pdf"
            />
          }
        />
        <Route
          path="/documents/di-education-society"
          element={
            <DocumentViewer
              title="DI Education Society Registration Certificate"
              pdf="/documents/DI Education Society Registration Certificate.pdf"
            />
          }
        />
        <Route
          path="/documents/academic-calendar"
          element={
            <DocumentViewer
              title="Academic Calendar 2025-2026"
              pdf="/documents/DIS Academic Calendar 2025-2026 Signed.pdf"
            />
          }
        />
        <Route
          path="/documents/mandatory-disclosure"
          element={
            <DocumentViewer
              title="Mandatory Disclosure Details"
              pdf="/documents/DIS_Mandatory Disclosure Details.pdf"
            />
          }
        />
        <Route
          path="/documents/fee-structure"
          element={
            <DocumentViewer
              title="Fee Structure"
              pdf="/documents/Fee Structure DIS Signed.pdf"
            />
          }
        />
        <Route
          path="/documents/fire-noc"
          element={
            <DocumentViewer
              title="Fire NOC Certificate"
              pdf="/documents/Fire NOC.pdf"
            />
          }
        />
        <Route
          path="/documents/land-certificate-signed"
          element={
            <DocumentViewer
              title="Land Certificate (Signed)"
              pdf="/documents/Land Certificate_Signed.pdf"
            />
          }
        />
        <Route
          path="/documents/land-certificate"
          element={
            <DocumentViewer
              title="Land Certificate"
              pdf="/documents/Land Certificate.pdf"
            />
          }
        />
        <Route
          path="/documents/pta"
          element={
            <DocumentViewer
              title="PTA Document"
              pdf="/documents/PTA_DIS.pdf"
            />
          }
        />
        <Route
          path="/documents/registration"
          element={
            <DocumentViewer
              title="Registration Certificate"
              pdf="/documents/Registration Certificate DIS.pdf"
            />
          }
        />
        <Route
          path="/documents/self-certificates"
          element={
            <DocumentViewer
              title="Self Certificates"
              pdf="/documents/Self Certificates.pdf"
            />
          }
        />
        <Route
          path="/documents/smc"
          element={
            <DocumentViewer
              title="SMC Document"
              pdf="/documents/SMC_DIS Signed.pdf"
            />
          }
        />

      </Routes>
      <Footer />
    </div>
  );
};

export default App;
